/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {  Checkbox, Input } from 'semantic-ui-react';
import FilterOperators from './FilterOperators';

const CheckboxFilter = ({
  filter,
  field,
  UpdateFilter,
  filterData,
  displayfield,
  header,
  uitype,
  remove,
  color,
}) => {
  const [operator, setOperator] = useState('equalto');
  const [fieldvalue, setFieldvalue] = useState(false);

  useEffect(() => {
    if (filter.value != null) {
      setFieldvalue(filter.value);
      setOperator(filter.operator);
      updatefilter(filter.value)
    } else {
        updatefilter(false)
    }
    // eslint-disable-next-line
  }, []);


  const handleEnter = e => {
    if (e.keyCode === 13) {
      filterData()
    }
  };

  const updatefilter = (data, tmpoperator) => {

    setFieldvalue(data);

    if (tmpoperator !== undefined) {
      const filterObject = {
        field,
        header,
        value: data,
        operator: tmpoperator,
        displayfield,
        uitype,
      };
     
      UpdateFilter(filterObject);
    } else {
      const filterObject = { field, header, value: data, operator, displayfield, uitype };
      UpdateFilter(filterObject);
    }
  };

  const changeOperator = (newoperator) => {
    setOperator(newoperator);
    updatefilter(fieldvalue, newoperator);
  };

  const removeFilter = (newfield) => {
    remove(newfield);
  };

  const filterOption = [
    { key: 'equalto', text: 'Equal to', value: 'equalto' },
    // { key: 'isnull', text: 'Is empty (null)', value: 'isnull' },
    // { key: 'isnotnull', text: 'Is not empty (not null)', value: 'isnotnull' },
  ];
  const displayvalue = operator === 'isnull' ? 'Empty (is null)' : 'Not empty (is not null)';

  return (
    <div style={{ marginBottom: '23px', width: '100%' }}>
      <FilterOperators
        header={header}
        operator={operator}
        filterOption={filterOption}
        RemoveAction={removeFilter}
        RemoveActionValue={field}
        ChangeOperator={changeOperator}
        color={color}
      />

      {operator === 'isnull' || operator === 'isnotnull' ? (
        <Input style={{ width: '100%' }} value={displayvalue} />
      ) : (
        <Checkbox
          checked={fieldvalue}
          onKeyDown={handleEnter}
          onChange={(e, data) => updatefilter(data.checked)}
          style={{ width: '100%' }}
        />
      )}
    </div>
  );
};



export default CheckboxFilter;
